/* eslint-disable no-unused-vars */
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import {
  BASE_ADDITIONAL_TAXABLE_MONTHS,
  BASE_ADDITIONAL_TAXABLE_QUARTERS,
  FIRST_DAY_IN_MONTH,
  MONTHS_IN_YEAR,
  QUARTERS_IN_YEAR,
  TODAYS_DATE,
  ZERO
} from './constants';

const monthsInAQuarter = 3;

function getZeroIndexedCurrentQuarter(date = TODAYS_DATE) {
  return Math.floor((date.getMonth() + monthsInAQuarter) / monthsInAQuarter) - 1;
}

export function generateTaxablePeriods({ earliestReportablePeriod, yearsAvailableToReport }) {
  const taxablePeriods = {};
  const additionalYearsToReport = yearsAvailableToReport || TODAYS_DATE.getFullYear() - earliestReportablePeriod.getFullYear();

  for (let i = 0; i <= additionalYearsToReport; i++) {
    const reportingYear = TODAYS_DATE.getFullYear() - i;
    const additionalReportingPeriods = BASE_ADDITIONAL_TAXABLE_QUARTERS;

    let startingPeriod = 0;
    let endingPeriod = 4;

    /**
     * First iteration (current year)
     *  Only want to get quarters that have already past
     *    Adjust ending period
     * Last iteration (earliest year)
     *  Only want to get quarters beyond and included the current quarter
     *    Adjust starting period
     * In between iterations (years between current and earliest)
     *  Want all quarters
     */
    if (!i) {
      /**
       * Subtract by 2, because we want to convert the one indexing to zeroth index
       *  then get the preceding period by subtracting one again
       */
      endingPeriod = getZeroIndexedCurrentQuarter();

      /**
       * This is the condition for when the preceding quarter is the last quarter of the year before the current
       * If this is the case, then we do not want to add any quarters for the current year and go to the preceding year
       * e.g.
       *  Current year = 2021
       *  Current month = Jan (getMonth will return 0)
       *  Math.floor((0 + 3) + 3) - 1 = 0 (will get same result for Feb and Mar)
       */
      if (!endingPeriod) continue;
    } else if (i === additionalYearsToReport) {
      /**
       * We want to include the current quarter in the earliest
       *  reportable year to have X whole years in quarters
       */
      startingPeriod = getZeroIndexedCurrentQuarter();

      if (earliestReportablePeriod) {
        const earliestReportableYear = earliestReportablePeriod.getFullYear();
        if (earliestReportableYear > reportingYear) break;

        startingPeriod = getZeroIndexedCurrentQuarter(earliestReportablePeriod);
      }
    }

    set(
      taxablePeriods,
      reportingYear,
      cloneDeep(additionalReportingPeriods.slice(startingPeriod, endingPeriod)),
    );
  }

  const mostRecentYearInTaxablePeriods = Math.max(
    ...Object.keys(taxablePeriods).map((taxableYear) => Number(taxableYear))
  );

  const mostRecentPeriodInMostRecentYear =
    taxablePeriods[mostRecentYearInTaxablePeriods].length - 1;

  const mostRecentPeriodYearPath = `[${mostRecentYearInTaxablePeriods}][${mostRecentPeriodInMostRecentYear}]`;

  set(taxablePeriods, mostRecentPeriodYearPath, {
    ...taxablePeriods[mostRecentYearInTaxablePeriods][
      mostRecentPeriodInMostRecentYear
    ],
    checked: true,
    disabled: true,
    fixed: true, // prevents unchecking
  });

  return { taxablePeriods };
}

function calcDaysInMonth (year, month) {
  // Months come in as 0-indexed, so we need to add 1 to them for the call
  return new Date(year, month + 1, ZERO).getDate();
}

function calcDaysInQuarter(year, quarterIndex) {
  const startingMonth = quarterIndex * monthsInAQuarter;
  let days = 0;

  for (let i = startingMonth; i < startingMonth + monthsInAQuarter; i++) {
    days += calcDaysInMonth(year, i);
  }

  return days;
}

// function determinePeriodIndex(isQuarterly, index) {
//   if (isNaN(index)) {
//     if (isQuarterly) return listOfQuarterIndices[Math.floor(TODAYS_DATE.getMonth() / monthsInAQuarter) - 1];
//     return listOfMonthIndices[TODAYS_DATE.getMonth() - 1];
//   }

//   if (isQuarterly) return listOfQuarterIndices[index];
//   return listOfMonthIndices[index];
// }

function determineStartEndDates(isQuarterly, year, zeroIndexMonth) {
  const startingMonthIndex = isQuarterly ? zeroIndexMonth * monthsInAQuarter : zeroIndexMonth;
  const dateStart = new Date(year, startingMonthIndex);
  const dateEnd = isQuarterly ?
    new Date(year, startingMonthIndex + 2, new Date(year, startingMonthIndex + 3, 0).getDate()) :
    new Date(year, startingMonthIndex, new Date(year, startingMonthIndex + 1, 0).getDate())

  return { dateStart, dateEnd };
}

/**
 * Generates an object to render and parse in ReportRevenue component
 * @param {string} name name of the period
 * @param {number} year year
 * @param {number} period 0-index value of the period
 * @returns an object to render and parse in ReportRevenue component
 */
// export function getPeriodDetails({ name, year, period, isQuarterly }) {
//   const parsedYear = isNaN(year) ? TODAYS_DATE.getFullYear() : year;

//   const reportingPeriod = determinePeriodIndex(isQuarterly, period);

//   const retrievedTitle = isQuarterly ? QUARTERS_IN_YEAR[reportingPeriod] : MONTHS_IN_YEAR[reportingPeriod];
//   const title = name || `${retrievedTitle} ${parsedYear}`

//   const dayCalcFn = isQuarterly ? calcDaysInQuarter : calcDaysInMonth;
//   const daysInPeriod = dayCalcFn(Number(parsedYear), Number(reportingPeriod))

//   const { dateStart, dateEnd } = determineStartEndDates(isQuarterly, parsedYear, reportingPeriod);

//   console.log('dateStart:', dateStart);
//   console.log('dateEnd:', dateEnd);

//   return {
//     title,
//     dateStart: String(dateStart),
//     dateEnd: String(dateEnd),
//     daysInPeriod,
//     sort: String(new Date(parsedYear, reportingPeriod, Number(FIRST_DAY_IN_MONTH))),
//   };
// }

